import React, { useState } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import './table.css'
import {
    TablePagination,
} from "@material-ui/core";
import { showText } from '../../helpers/textValidation';
import { useEffect } from 'react';
const PgDynamicTable = ({ count, pagination, setPagination, tableData, Pagination = true, onFilter, edit }) => {


    let { header, rows } = tableData
    const handleChangePage = (event, newPage) => {
        setPagination({
            ...pagination, offSet: newPage
        })
    };
    const handleChangeRowsPerPage = (event) => {
        setPagination({
            ...pagination, limit: event.target.value
        })
    };


    useEffect(() => {
    }, [tableData])
    useEffect(() => {
        setPagination({
            ...pagination, offSet: 0
        })
    }, [edit])

    return (
        <Paper>
            <TableContainer component={Paper}>
                <Table sx={{ width: "100%" }} aria-label="simple table">
                    <TableHead style={{ backgroundColor: "#2963ad" }}>
                        <TableRow style={{ backgroundColor: "#2963ad" }}>
                            {header.map((col) => (
                                <TableCell>
                                    <p style={{ whiteSpace: "nowrap" }}>
                                        {col}
                                    </p>
                                </TableCell>
                            ))
                            }
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {rows?.map((row, index) => (
                            <TableRow
                                key={index}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                {row?.map((cols, index) => (
                                    <TableCell component="th" scope="row" >
                                        <p style={{ whiteSpace: "nowrap" }}>
                                            {showText(cols)}
                                            {/* {cols} */}
                                        </p>
                                    </TableCell>
                                ))

                                }
                            </TableRow>
                        ))}

                    </TableBody>

                </Table>
                {/* { !rows?.length && <h2 style={{textAlign:'center',background:'white',height:'44px', display:'flex',justifyContent:'center',alignItems:'center',borderRadius:'10px'}}>No data Found!</h2>} */}
                {!rows?.length && <p className='notFoundTable'>No data Found!</p>}

            </TableContainer>
            {Pagination ? <TablePagination
                rowsPerPageOptions={[5, 10, 15, 100]}
                component="div"
                count={count || 0}
                rowsPerPage={pagination?.limit}
                page={pagination?.offSet}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            /> : <></>}
        </Paper>

    )
}

export default PgDynamicTable